import { Routes } from '@angular/router';
import { TabsPage } from './tabs.page';
import { HomePage } from '../pages/home/home.page';
import { BrowsePage } from '../pages/browse/browse.page';
import { OrdersPage } from '../pages/orders/orders.page';
import { AccountPage } from '../pages/account/account.page';
import { MedicineResultsPage } from '../pages/medicine-results/medicine-results.page';
import { ScriptWalletPage } from '../pages/script-wallet/script-wallet.page';

export const routes: Routes = [
  {
    path: 'tabs',
    component: TabsPage,
    children: [
      {
        path: 'home',
        component: HomePage,
      },
      {
        path: 'browse',
        children: [
          {
            path: '',
            component: BrowsePage,
          },
          {
            path: 'medicine-results/:id',
            component: MedicineResultsPage
          }
        ]
      },
      {
        path: 'my-scripts',
        component: ScriptWalletPage
      },
      {
        path: 'orders',
        component: OrdersPage
      },
      {
        path: 'account',
        component: AccountPage
      },
      {
        path: '',
        redirectTo: '/tabs/home',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    redirectTo: '/tabs/home',
    pathMatch: 'full',
  },
];
